import axios from "axios";
export const getCurrentAzureToken = params => {
  return axios.request({
    url: `/api/v2/binding/getCurrentAzureToken`,
    method: "get",
    params
  });
};
export const refreshAzureToken = data => {
  return axios.request({
    url: `/api/v2/binding/refreshAzureToken`,
    method: "post",
    data
  });
};